import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ReactSpeedometer from 'react-d3-speedometer';
import "./VehicleReportCard.css"; // for additional styling
import { useVehicleData } from './context';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
// import { PDFDocument } from 'pdf-lib';

import {
    Settings,
    Ban,
    AlertOctagon,
    AlertTriangle,
    GaugeCircle,
    Droplets,
    Download
} from "lucide-react";

import {
    Activity,
    Gauge,
    ArrowDownCircle,
    Repeat,
    TimerReset,
} from "lucide-react";
import moment from 'moment';
import DownloadModal_MA_BUS from './DownloadModal_MA_Bus';


const DownloadVehicleInfoPDF = () => {
    const hiddenRef = useRef();
    const { GlobalData, setGlobalData, handleDownloadAllReport } = useVehicleData();
    const { isLoading, error, sendReq2: fetchData } = useHttp();


    const handleSendPDF = async () => {
        const element = hiddenRef.current;

        // Wait to ensure DOM is painted
        await new Promise((res) => setTimeout(res, 300));

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
        });

        const imgData = canvas.toDataURL('image/jpeg');
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });

        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;


        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        const pdfBlob = pdf.output('blob');

        return new File([pdfBlob], "Driver-report_card.pdf", { type: "application/pdf" });
    }

    const handleEmailClick = async () => {
        const file = await handleSendPDF()

        const formData = new FormData();
        formData.append("files", file);

        fetchData(
            {
                url: API_URL_MAIN + `email/send-gmail`,
                body: formData,
            },
            () => alert("Email sent successfully")
        );
    };

    const handleDownload = async () => {
        const element = hiddenRef.current;

        await new Promise((res) => setTimeout(res, 300));

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
        });

        const imgData = canvas.toDataURL('image/jpeg');
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });

        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('Driver-report_card.pdf');
    };

    const pageStyle = {
        position: 'absolute',
        width: '1240px',
        height: '1754px',
        backgroundColor: '#fff',
        padding: '40px',
        boxSizing: 'border-box',
        fontFamily: 'Arial, sans-serif',
        border: '1px solid #ccc',
        margin: '0 auto',
        left: '-9999px',

    };

    const tips = [
        {
            icon: <Gauge size={20} />,
            title: "Your vehicle’s Acceleration Pedal Position",
            value: "19.43%",
            valueColor: "text-danger",
            desc:
                "Press Acceleration Pedal Position slowly according to Speed, Avoid harsh pressing",
            benchmark: "26.6 %",
        },
        {
            icon: <ArrowDownCircle size={20} />,
            title: "You drove the vehicle at an Average speed of",
            value: "25.68%",
            valueColor: "text-danger",
            desc:
                "For better mileage, try to drive the vehicle at an average speed of 40-50 km/h",
            benchmark: "32.28 %",
        },
        {
            icon: <Repeat size={20} />,
            title: "Your vehicle is Adhering gear shifts",
            value: "78.007%",
            valueColor: "text-danger",
            desc:
                "Keep changing gears according to the indicators shown on the cluster meter to maintain your vehicle's optimal performance score",
            benchmark: "95 %",
        },
        {
            icon: <TimerReset size={20} />,
            title: "Your vehicle has been Idling for",
            value: "8.64%",
            valueColor: "text-danger",
            desc:
                "Avoid leaving vehicle idling for too long; stop it only when necessary",
            benchmark: "7.41 %",
        },
    ];

    const startDate = moment(GlobalData?.globalFilter?.startDate);
    const endDate = moment(GlobalData?.globalFilter?.endDate);

    const diffInDays = endDate.diff(startDate, 'days') + 1;


    return (
        <>
            <div  >
                <style>
                    {`
        .custom-font-xs { font-size: 13.33px; }
        .custom-font-sm { font-size: 14.66px; }
        .custom-font-base { font-size: 16.66px; }
        .custom-font-md { font-size: 18.66px; }
        .custom-font-lg { font-size: 21.33px; }
        .download-btn-ma_bus{
        
        }
        `}
                </style>
                {
                    GlobalData?.primaryVehicleDetails?.vehicleId ?
                        <><Download data-toggle="modal" data-target={"#Download_MSbus_Analysis"} size={14} color="#666" />
                            {/* <Download onClick={handleDownload}  size={14} color="#666" /> */}
                            {/* <Download  onClick={() => handleClick()} size={14} color="#666" /> */}
                        </>
                        : <></>}
                {/* Fully rendered but hidden visually (not using display: none!) */}

                <div
                    ref={hiddenRef}
                    style={pageStyle}
                // style={{
                //     position: 'absolute',
                //     left: '-9999px',
                //     width: '794px', // equivalent to 210mm in px at 96dpi
                //     height: '1123px', // 297mm in px at 96dpi
                //     backgroundColor: '#fff',
                //     padding: '20px',

                // }}
                >
                    <div className="container-fluid px-4 py-3" style={{ backgroundColor: "#ecedf6", minHeight: "1650px" }}>
                        <div className="container my-4 report-card" style={{ minWidth: "1100px" }}>
                            {/* Title Row */}
                            <div className="d-flex justify-content-between align-items-center mb-1 px-2">
                                <div className="report-title fw-semibold text-white custom-font-lg">
                                    Report Card; Increase Mileage, Save Energy
                                </div>
                                <div className="text-end ">
                                    <div className="date-text custom-font-md fw-semibold">{GlobalData?.globalFilter?.startDate} To {GlobalData?.globalFilter?.endDate}</div>
                                    <div className="date-subtext custom-font-sm">{diffInDays} Days</div>
                                </div>
                            </div>

                            {/* Card */}
                            <div className=" d-flex justify-content-between align-items-center flex-wrap px-3 py-3">
                                {/* Left Section */}
                                <div className="d-flex align-items-center gap-3">
                                    <div className='text-start'>
                                        <div className="fw-bold text-white custom-font-md"   >{GlobalData?.primaryVehicleDetails?.vehicleId}</div>
                                        <div className="small-label custom-font-md"  >{GlobalData?.primaryVehicleDetails?.vehicle_registration_number}</div>
                                        <div className="small-label custom-font-md"  >{GlobalData?.primaryVehicleDetails?.PL} | {GlobalData?.primaryVehicleDetails?.LOB}</div>
                                        {/* <div className="yellow-badge">Average Performance</div> */}
                                    </div>
                                    <div className="text-start ml-4 ">
                                        <div className='custom-font-md' ><strong >{GlobalData?.runningHistory?.distance?.primaryVehicle}</strong> Km Driven</div>
                                        <div className='custom-font-md'><strong >{GlobalData?.runningHistory?.energyConsumed?.primaryVehicle}</strong> KWh Usage</div>
                                        <div className='custom-font-md' ><strong >{GlobalData?.energyEfficiency?.energyEfficiency?.primaryVehicle}</strong> KWh/Km Mileage</div>
                                    </div>
                                </div>

                                {/* Right Section */}

                            </div>
                        </div>

                        <div className="d-flex mt-3 gap-2">
                            {/* Left Panel */}
                            <div className="cols-4" >
                                <div className="card rounded-4 shadow-sm p-3 mileage-card" style={{ width: "400px" }}>
                                    <div className="card-body">
                                        <div className="d-flex flex-column align-items-start">
                                            <h6 className="text-primary fw-semibold me-0 fw-bold text-start custom-font-md">Increase your energy savings:</h6>
                                            <div className="text-muted  custom-font-base">Best Mileage: <span className="text-success fw-bold">{GlobalData?.energyEfficiency?.energyEfficiency?.bestVehicle} {" KWh/Km"} </span></div>
                                        </div>

                                        <div className="d-flex justify-content-center my-2">
                                            <ReactSpeedometer
                                                value={Number(GlobalData?.energyEfficiency?.energyEfficiency?.primaryVehicle)}
                                                minValue={0}
                                                maxValue={16}
                                                needleColor="#ff9f00"
                                                segments={5}
                                                segmentColors={["#00b894", "#00b894", "#00b894", "#00b894", "#00b894"]}
                                                height={140}
                                                ringWidth={18}
                                                needleTransitionDuration={1000}
                                                customSegmentStops={[0, 4, 8, 12, 16]}
                                                maxSegmentLabels={0}
                                                currentValueText=""
                                            />
                                        </div>
                                        <h6 className="mb-1 custom-font-base"><strong>{GlobalData?.energyEfficiency?.energyEfficiency?.primaryVehicle} KWh/Km</strong></h6>
                                        <div className="text-muted custom-font-sm mb-2">Your Mileage</div>
                                    </div>
                                </div>


                                {/* Report incidents */}
                                <div className="mt-3 card rounded-4 shadow-sm p-3 incident-card" style={{ width: "400px" }}>
                                    <div className="card-body text-start">
                                        <div className="d-flex flex-column align-items-start mb-2">
                                            <h6 className="text-primary fw-semibold me-0 fw-bold custom-font-md custom-font-md">Reported Incidents:</h6>
                                        </div>

                                        {[
                                            { icon: <Settings size={18} />, label: "Regeneration", value: GlobalData?.drivingBehavior?.primaryVehicleData?.regeneration },
                                            { icon: <Ban size={18} />, label: "RPM", value: GlobalData?.drivingBehavior?.primaryVehicleData?.RPM },
                                            { icon: <AlertOctagon size={18} />, label: "Coasting", value: GlobalData?.drivingBehavior?.primaryVehicleData?.coasting },
                                            { icon: <AlertTriangle size={18} />, label: "Idling", value: GlobalData?.drivingBehavior?.primaryVehicleData?.idling },
                                            { icon: <GaugeCircle size={18} />, label: "Acc. Pedal Position", value: GlobalData?.drivingBehavior?.primaryVehicleData?.accPedalPosition },
                                            { icon: <Droplets size={18} />, label: "Vehicle Speed Distribution", value: GlobalData?.drivingBehavior?.primaryVehicleData?.vehicleSpeedDistribution },
                                        ].map((item, index) => (
                                            <div className="d-flex align-items-start gap-3 mb-3 text-start " key={index}>

                                                <div className='bg-light p-2 rounded-circle'>
                                                    <div className="icon-circle">{item.icon}</div>
                                                </div>
                                                <div>
                                                    <div className="incident-label fw-bold custom-font-base" style={{ color: "#131414" }} >{item.label}</div>
                                                    <div className="incident-value custom-font-sm">{item.value != null ? item.value + " %" : "--"}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Right Panel */}
                            <div className="cols-8  mt-0" >
                                <div className="card" style={{ width: "700px" }}>
                                    <div className="container py-4">
                                        {/* Section 1 */}
                                        <div className="d-flex flex-column align-items-start mb-2">
                                            <h6 className="text-primary fw-semibold me-0 fw-bold custom-font-md">Know What Went <span className="text-success">Right</span>:</h6>
                                        </div>


                                        {[
                                            { icon: <Settings size={18} />, label: "Regeneration", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.regeneration, benchmark: 42, },
                                            { icon: <Ban size={18} />, label: "RPM", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.RPM, benchmark: 13, },
                                            { icon: <AlertOctagon size={18} />, label: "Coasting", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.coasting, benchmark: 57, },
                                            { icon: <AlertTriangle size={18} />, label: "Idling", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.idling, benchmark: 31, },
                                            { icon: <GaugeCircle size={18} />, label: "Acc. Pedal Position", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.accPedalPosition, benchmark: 24, },
                                            { icon: <Droplets size={18} />, label: "Vehicle Speed Distribution", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.vehicleSpeedDistribution, benchmark: 25, },
                                        ].filter(item => item.label == "Idling" ? item.value <= item.benchmark : item.value >= item.benchmark)?.map((item, idx) => (
                                            <div className="report-green-color bg-opacity-25 rounded-3 p-3 mb-2 d-flex align-items-center gap-2">
                                                <Activity size={20} className="text-success" />
                                                <span className="fw-medium custom-font-base" style={{ color: "gray" }}>Green {item.label} Band</span>
                                            </div>
                                        ))}

                                        <div className="d-flex flex-column align-items-start mb-2 mt-5">
                                            <h6 className="fw-bold text-primary custom-font-md">
                                                To Get Extra Mileage,{" "}
                                                <span className="text-warning">Pay Special Attention To These Things</span> -
                                            </h6>
                                        </div>

                                        {[
                                            { icon: <Settings size={18} />, label: "Regeneration", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.regeneration, benchmark: 42, },
                                            { icon: <Ban size={18} />, label: "RPM", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.RPM, benchmark: 13, },
                                            { icon: <AlertOctagon size={18} />, label: "Coasting", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.coasting, benchmark: 57, },
                                            { icon: <AlertTriangle size={18} />, label: "Idling", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.idling, benchmark: 31, },
                                            { icon: <GaugeCircle size={18} />, label: "Acc. Pedal Position", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.accPedalPosition, benchmark: 24, },
                                            { icon: <Droplets size={18} />, label: "Vehicle Speed Distribution", desc: "description", value: GlobalData?.drivingBehavior?.primaryVehicleData?.vehicleSpeedDistribution, benchmark: 25, },
                                        ]?.filter(item => item.label == "Idling" ? item.value >= item.benchmark : item.value <= item.benchmark)?.map((item, idx) => (
                                            <div
                                                key={idx}
                                                className="report-yellow-color bg-opacity-10 p-2 rounded-3 shadow-sm my-3"
                                            >
                                                <div className="d-flex align-items-center gap-2 mb-1">
                                                    <div className="bg-light p-3 rounded-circle ">
                                                        <div className="icon-circle">{item.icon}</div>
                                                    </div>
                                                    <div className="d-flex flex-column align-items-start ms-4 text-start w-100">
                                                        <div className="fw-bold text-dark w-100 ">
                                                            <span className='custom-font-base'>{item.label}{" "}</span>
                                                            <span className={`text-danger custom-font-base`}>
                                                                {item.value + " %"}
                                                            </span>
                                                        </div>
                                                        <div className="text-success fw-medium custom-font-sm mt-1">
                                                            Best Score (Benchmark) : {item.benchmark + " %"}
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <DownloadModal_MA_BUS handleEmailClick={handleEmailClick} handleDownload={handleDownload} />
        </>
    );
};

export default DownloadVehicleInfoPDF;
